<script setup lang="ts">
import Footer from "@/components/UI/Footer.vue";
import Header from "@/components/UI/Header.vue";
import { useVueLoaderStore } from "@/stores/vueLoader";
import { computed } from "vue";
import { useI18n } from 'vue-i18n';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import { useRoute } from 'vue-router';

//==i18n
const { locale } = useI18n();
const lang = ['tw', 'en'];
let langIdx = 0;
const handleChangeLanguage = (e) => {
  langIdx = +!langIdx;
  locale.value = lang[langIdx];
};

//==VueLoader
const VueLoaderStore = useVueLoaderStore();

//==publications
const publications = ['brochures', '3D', 'journal'];

//==判斷nav dropdown item被點擊
const routeName = computed(() => useRoute().name);

</script>

<template>
  <!-- Nav Start -->
  <nav class="navbar navbar-expand-lg bg-dark navbar-dark sticky-top py-lg-0 px-lg-5 wow fadeIn" data-wow-delay="0.1s">
    <a href="index.html" class="navbar-brand ms-4 ms-lg-0">
      <h1 class="mb-0 text-primary fw-bold">P-Alert</h1>
      <p>Strong Motion Network</p>
    </a>
    <button type="button" class="navbar-toggler me-4" data-bs-toggle="collapse" data-bs-target="#navbarCollapse">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse navbar-nav p-lg-0 justify-content-lg-end" id="navbarCollapse">
      <router-link class="nav-item nav-link" to="/">{{ $t('homePage') }}</router-link>
      <router-link class="nav-item nav-link" to="/stations">{{ $t('stationPage') }}</router-link>
      <router-link class="nav-item nav-link" to="/realtime">{{ $t('displayPage') }}</router-link>
      <router-link class="nav-item nav-link" to="/database">{{ $t('dataSearchPage') }}</router-link>
      <!-- <router-link class="nav-item nav-link" to="/publications">{{ $t('publicationsPage') }}</router-link> -->
      <div class="nav-item dropdown" ref="div1">
        <a href="#" :class="`nav-link dropdown-toggle ${routeName === 'publicationsPage' ? ' router-link-active' : ''}`"
          data-bs-toggle="dropdown" role="button">{{
        $t('publicationsPage')
      }}</a>
        <div class="dropdown-menu m-0">
          <router-link v-for="item in publications" class="dropdown-item" :to="('/publications/' + item)"> {{
        $t(item + 'Page')
      }}</router-link>
        </div>
      </div>
      <router-link class="nav-item nav-link" to="/help">{{ $t('helpPage') }}</router-link>
      <span class="nav-item nav-link">|</span>
      <a class="nav-item nav-link" @click="handleChangeLanguage">
        {{ $t('langTag') }}
      </a>
    </div>
  </nav>
  <!-- Nav End -->
  <div class="container-fluid p-0 mb-5">
    <Header />
  </div>
  <div class="container">
    <router-view />
  </div>
  <div class="container-fluid p-0 mt-5">
    <Footer />
  </div>
  <loading :active="VueLoaderStore.loaderActive" is-full-page="true" loader="bars" width="100" height="100"
    background-color="#fff" />
</template>

<style>
:root {
  --primary: #eb1616;
  --secondary: #191c24;
  --light: #6c7293;
  --dark: #000000;
}

.text-primary {
  color: var(--primary) !important;
}

body {
  background-color: var(--dark) !important;
  font-family: "Oswald", sans-serif;
}

/*** Navbar ***/
.navbar .dropdown-toggle::after {
  border: none;
  content: "\f107";
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
  vertical-align: middle;
  margin-left: 8px;
}

span.nav-link {
  cursor: default !important;
}

.navbar .navbar-nav .nav-link {
  margin-right: 30px;
  padding: 20px 0;
  color: var(--light);
  font-family: "Oswald", sans-serif;
  font-size: 18px;
  font-weight: 600;
  text-transform: uppercase;
  outline: none;
  white-space: nowrap;
  cursor: pointer;
}

.navbar .navbar-nav .nav-link:hover,
.router-link-active,
.navbar .navbar-nav .nav-link.active {
  color: var(--primary) !important;
}

.navbar.sticky-top {
  /* top: -100px; */
  transition: 0.5s;
}

@media (max-width: 991.98px) {

  .navbar .navbar-nav .nav-link,
  .navbar.shadow-sm .navbar-nav .nav-link {
    margin-right: 0;
    padding: 10px 0;
  }

  .navbar .navbar-nav {
    margin-top: 8px;
    border-top: 1px solid var(--light);
  }
}

@media (min-width: 992px) {
  .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }


  .navbar.shadow-sm .navbar-nav .nav-link {
    padding: 20px 0;
  }


  .navbar .nav-item .dropdown-menu {
    display: block;
    border: none;
    margin-top: 0;
    top: 150%;
    opacity: 0;
    visibility: hidden;
    transition: 0.5s;
  }

  .navbar .nav-item:hover .dropdown-menu {
    top: 80%;
    visibility: visible;
    transition: 0.5s;
    opacity: 1;
  }

  .navbar .nav-item .dropdown-menu a:active,
  .navbar .nav-item .dropdown-menu .router-link-active {
    color: #fff !important;
    background-color: var(--primary);

  }
}
</style>
